import { Components } from '@mui/material/styles';
import { Theme } from '@mui/material';

export const flowTableHead: Components<Theme>['MuiTableHead'] = {
  defaultProps: {},
  styleOverrides: {
    root: {
      borderColor: 'inherit',
    },
  },
};
